module.exports = __webpack_public_path__ + "static/ch-him2-lp-quiz-4-d608881ab214fb5eb8ef901a771d2ad5.jpg";